import { Loader2 } from 'lucide-react';
import { copy } from '../lib/copy';

export { StatusBadge } from './StatusBadge';

export function LoadingState({ label = copy.common.loading }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 py-12 text-ops-muted">
      <Loader2 className="h-5 w-5 animate-spin" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="ops-card border-ops-danger/20 bg-ops-danger-soft text-center">
      <p className="text-sm text-ops-danger">{message}</p>
      {onRetry ? (
        <button type="button" onClick={onRetry} className="ops-btn-secondary mt-3">
          {copy.common.retry}
        </button>
      ) : null}
    </div>
  );
}

export function KpiCard({
  label,
  value,
  hint,
}: {
  label: string;
  value: string | number;
  hint?: string;
}) {
  return (
    <div className="ops-card">
      <p className="text-xs font-medium uppercase tracking-wide text-ops-muted">{label}</p>
      <p className="mt-2 font-display text-2xl font-semibold text-ops-text">{value}</p>
      {hint ? <p className="mt-1 text-xs text-ops-muted">{hint}</p> : null}
    </div>
  );
}

export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
      <div>
        <h1 className="text-[32px] font-bold leading-tight tracking-[-0.04em]">{title}</h1>
        {description ? <p className="mt-1 text-sm text-ops-muted">{description}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
}

export function EmptyState({ message }: { message: string }) {
  return (
    <div className="ops-card py-10 text-center text-sm text-ops-muted">{message}</div>
  );
}
